import moment from "moment-jalaali";
import Vue from "vue";
import { getToken, logout } from "@/utils/auth";
import store from "@/store";
export const TODAY = moment().format("jYYYY/jMM/jDD");
export const LOADING = "در حال بارگذاری. لطفا چند لحظه صبر نمایید.";
export const NODATA = "داده ای برای نمایش وجود ندارد.";

export const mobile = Vue.observable({ mobile: {} });
Object.defineProperty(Vue.prototype, "$mobile", {
  get() {
    return mobile.mobile;
  },
  set(value) {
    mobile.mobile = value;
  },
});
export const PostRequestStep_Enum = {
  PostRequest: 0,
  PostPayment: 1,
  EditPostRequest: 2,
};
export const PostRequestState_Enum = {
  NotPaid: 0,
  Paid: 1,
  Tagged: 2,
  SentToPostOffice: 3,
  Cancelled : 4
};
export const Jensiat_Enum = {
  Male: "1",
  Female: "2",
};
export function widthChanged() {
  if (window.innerWidth < 960) {
    if (!Vue.prototype.$mobile) Vue.set(Vue.prototype, "$mobile", true);
  } else if (Vue.prototype.$mobile) Vue.set(Vue.prototype, "$mobile", false);
}
export function monitorFocus() {
  var lastActive = window.document.hasFocus(); // 'static' memory between function calls

  // setInterval(() => {
  //     var isActive = window.document.hasFocus();
  //     if (lastActive != isActive) {
  //         var hasToken = store.getters.token != "" && getToken();
  //         if (isActive && hasToken) {

  //             store.dispatch("GetUserInfo");
  //         }
  //         lastActive = isActive; // store latest cookie
  //     }
  // }, 1000);
}

export function saveByteArray(array, fileName) {
  var byteCharacters = atob(array);
  var byteNumbers = new Array(byteCharacters.length);
  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  var byteArray = new Uint8Array(byteNumbers);
  var blob = new Blob([byteArray]);
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, fileName);
  } else {
    const elem = window.document.createElement("a");
    elem.href = window.URL.createObjectURL(blob);
    elem.download = fileName;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }
  store.commit(
    "SET_SNACKBAR_TEXT",
    "دانلود با موفقیت به پایان رسید. شما می توانید از بخش دانلود ها فایل مورد نظر را مشاهده  فرمایید."
  );
}

export function toArabicCharacter(string) {
  var obj = {
    ك: "ک",
    // 'دِ': 'د',
    // 'بِ': 'ب',
    // 'زِ': 'ز',
    // 'ذِ': 'ذ',
    // 'شِ': 'ش',
    // 'سِ': 'س',
    // 'ى': 'ی',
    ي: "ی",
    // '١': '۱',
    // '٢': '۲',
    // '٣': '۳',
    // '٤': '۴',
    // '٥': '۵',
    // '٦': '۶',
    // '٧': '۷',
    // '٨': '۸',
    // '٩': '۹',
    // '٠': '۰',
  };

  Object.keys(obj).forEach(function(key) {
    string = string.replace(new RegExp(obj[key], "g"), key);
    //  string = string.replaceAll(obj[key], key);
  });
  return string.toLowerCase();
}

export function toArabicDigit(string) {
  var obj = {
    "1": "۱",
    "2": "۲",
    "3": "۳",
    "4": "۴",
    "5": "۵",
    "6": "۶",
    "7": "۷",
    "8": "۸",
    "9": "۹",
    "0": "۰",
  };

  Object.keys(obj).forEach(function(key) {
    string = string.replace(new RegExp(obj[key], "g"), key);
    //  string = string.replaceAll(obj[key], key);
  });
  return string;
}

export const convertHTMLBody = (body) => {
  const str = body.replace(/(?:\r\n|\r|\n)/g, "<br/>");
  return str;
};
//checkCookie()

window.addEventListener("resize", widthChanged);
//window.addEventListener("beforeunload", logout);
